import React from "react";
import Icon from "./Icon";
import { useI18n } from "../i18n";
import { C, R, S } from "../theme";

const DISMISS_KEY = "sb_install_dismissed";
export function clearInstallDismiss() { localStorage.removeItem(DISMISS_KEY); }

export default function InstallInstructions({ open, onClose, onAdded, deferredInstall }) {
  const { t: tr } = useI18n();
  if (!open) return null;
  const ua = window.navigator.userAgent || "";
  const isIOS = /iphone|ipad|ipod/i.test(ua);
  const isAndroid = /android/i.test(ua);
  const platform = isIOS ? "IPHONE / IPAD — SAFARI" : isAndroid ? "ANDROID — CHROME" : "DESKTOP & MOBILE";

  const steps = isIOS
    ? [
        ["Tap the Share button", "In the Safari toolbar, tap the Share icon (a square with an up arrow)."],
        ["Choose 'Add to Home Screen'", "Scroll the share sheet and tap \u201cAdd to Home Screen\u201d."],
        ["Tap 'Add'", "Confirm in the top-right \u2014 SafeBook now opens full-screen like a native app."],
      ]
    : isAndroid
    ? [
        ["Open the menu", "In Chrome, tap the \u22ee menu (top-right)."],
        ["Tap 'Add to Home screen'", "Choose \u201cAdd to Home screen\u201d (or \u201cInstall app\u201d if shown)."],
        ["Tap 'Install' / 'Add'", "Confirm \u2014 SafeBook installs to your home screen and opens full-screen."],
      ]
    : [
        ["On iPhone (Safari)", "Tap the Share icon \u2192 \u201cAdd to Home Screen\u201d \u2192 Add."],
        ["On Android (Chrome)", "Tap the \u22ee menu \u2192 \u201cAdd to Home screen\u201d / \u201cInstall app\u201d \u2192 Install."],
        ["On desktop (Chrome/Edge)", "Click the install icon at the right of the address bar."],
      ];

  return (
    <div className="modal-backdrop modal-center" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} data-testid="install-instructions" style={{ background: C.card, borderRadius: R.lg, padding: S.xl, width: "100%", maxWidth: 400, border: `1px solid ${C.borderStrong}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: S.sm, marginBottom: S.md }}>
          <div style={{ width: 40, height: 40, borderRadius: 10, background: C.amber, display: "flex", alignItems: "center", justifyContent: "center" }}><Icon name="shield-checkmark" size={22} color={C.black} /></div>
          <div className="display" style={{ color: C.text, fontSize: 22, fontWeight: 900 }}>{tr("install.addToHome")}</div>
        </div>
        <div data-testid="install-platform" style={{ color: C.amber, fontSize: 12, fontWeight: 800, letterSpacing: 1, marginBottom: S.md }}>{platform}</div>
        {steps.map(([title, body], i) => (
          <div key={i} style={{ display: "flex", gap: S.md, marginBottom: S.md }}>
            <div style={{ width: 28, height: 28, borderRadius: 14, background: C.amber, color: C.black, fontWeight: 900, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{i + 1}</div>
            <div><div style={{ color: C.text, fontWeight: 800, fontSize: 15 }}>{title}</div><div style={{ color: C.sub, fontSize: 14, marginTop: 2, lineHeight: 1.4 }}>{body}</div></div>
          </div>
        ))}
        {deferredInstall && (
          <button data-testid="install-modal-native" className="pressable" onClick={deferredInstall} style={{ background: C.green, color: C.black, fontWeight: 900, borderRadius: R.md, minHeight: 52, width: "100%", marginTop: S.sm }}>{tr("install.installAuto")}</button>
        )}
        {onAdded && (
          <button data-testid="install-added-btn" className="pressable" onClick={onAdded} style={{ background: C.amber, color: C.black, fontWeight: 900, borderRadius: R.md, minHeight: 52, width: "100%", marginTop: S.sm }}>{tr("install.addedBtn")}</button>
        )}
        <button data-testid="install-later" className="pressable" onClick={onClose} style={{ color: C.muted, fontWeight: 700, fontSize: 14, width: "100%", marginTop: S.md }}>{tr("install.closeLabel")}</button>
      </div>
    </div>
  );
}
